import { Service, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Service()
export class PageTitleService {
  private readonly titleService = inject(Title);
  private readonly translate = inject(TranslateService);

  setPageTitle(translationKey: string): void {
    const appTitle = this.translate.instant('layout.menu.appTitle');
    const pageTitle = this.translate.instant(translationKey);
    const fullTitle = `${appTitle}: ${pageTitle}`;
    this.titleService.setTitle(fullTitle);
  }
}
